import { render, staticRenderFns } from "./transferList.vue?vue&type=template&id=44616c3e&scoped=true&"
import script from "./transferList.vue?vue&type=script&lang=js&"
export * from "./transferList.vue?vue&type=script&lang=js&"
import style0 from "./transferList.vue?vue&type=style&index=0&id=44616c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44616c3e",
  null
  
)

export default component.exports